export default __webpack_public_path__ + "static/media/rx.0fba3e8f.png";